import { useEffect, useRef } from "react";
import { cleanupRecaptcha } from "./use-recaptcha";

export function useRecaptchaV2(
	siteKey: string,
	active: boolean,
	onVerify: (token: string) => void,
	containerId: string = "recaptcha-v2-container",
) {
	const onVerifyRef = useRef(onVerify);
	onVerifyRef.current = onVerify;

	useEffect(() => {
		if (!siteKey || !active) return;

		if (document.querySelector('script[src*="recaptcha/enterprise.js"]'))
			return;

		const script = document.createElement("script");
		script.src = "https://www.google.com/recaptcha/enterprise.js";
		script.async = true;
		script.defer = true;
		script.onload = () => {
			window.grecaptcha.enterprise.ready(() => {
				window.grecaptcha.enterprise.render(containerId, {
					sitekey: siteKey,
					action: "LOGIN",
					callback: (token: string) => onVerifyRef.current(token),
				});
			});
		};
		document.body.appendChild(script);

		return () => {
			cleanupRecaptcha();
		};
	}, [siteKey, active, containerId]);
}
